const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPsychiatry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M25.257,6.495 c-0.055-0.074-1.376-1.83-3.763-3.015c-2.208-1.096-5.77-1.873-10.204,0.653c-0.159,0.096-3.902,2.409-4.458,6.709L6.83,10.864 l0.001,0.022c0.001,0.033,0.032,0.756,0.124,1.231l-3.05,3.629c-0.052,0.059-0.365,0.449-0.239,1.014 c0.155,0.698,0.901,1.338,2.218,1.901v4.432c-0.024,0.159-0.109,0.949,0.454,1.585c0.527,0.596,1.436,0.855,2.701,0.772l0.014-0.001 c0.009-0.001,0.887-0.097,1.366,0.362c0.241,0.231,0.345,0.58,0.311,1.035l-0.001,2.29h11.901c-0.099-0.729-0.517-5.03,2.536-9.397 c0.12-0.145,1.353-1.679,2.002-4.027C27.784,13.475,27.954,10.059,25.257,6.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.205,7.051c0,0-3.234,1.649-1.6,4.988 c0,0,1.018,2.037,4.997,1.516c0,0,0.829,1.587,3.434,1.374c0,0,1.966,0.805,2.582,2.297l0.403,0.9h1.494l-0.05-1.682 c0,0-0.118-0.687,0.711-0.758c0,0,1.682-0.426,1.587-2.51c0,0,0.213-0.71,0.545-0.118c0,0,0.26,0.639-0.047,1.255 c0,0,2.605-1.35,1.445-4.358c0,0-1.034-1.966-3.312-0.936c0,0-0.367,0.17-0.415-0.178c0,0-0.126-0.189,0.268-0.316 c0,0,1.169-0.756,2.59-0.046c0,0-0.143-2.59-3.869-3.285l0.269,0.703c0,0,0.102,0.275-0.138,0.354c0,0-0.219,0.094-0.356-0.142 c0,0-0.922-2.805-4.659-1.505l0.637,0.573c0,0,0.186,0.194,0.043,0.324c0,0-0.134,0.286-0.44-0.005c0,0-1.703-1.688-4.226-0.232 c0,0-1.871,1.007-0.888,2.961c0,0,0.163,0.273-0.108,0.356c0,0-0.247,0.165-0.437-0.214C10.666,8.368,10.278,7.902,10.205,7.051z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.393,10.88v-1.38h-1.05 c-0.063-0.239-0.158-0.464-0.28-0.673l0.743-0.743l-0.976-0.976l-0.743,0.743c-0.209-0.122-0.433-0.217-0.673-0.28v-1.05h-1.38 v1.05c-0.239,0.063-0.464,0.158-0.673,0.28l-0.743-0.743l-0.976,0.976l0.743,0.743c-0.122,0.209-0.217,0.434-0.28,0.673h-1.05v1.38 h1.05c0.063,0.239,0.158,0.464,0.28,0.673l-0.743,0.743l0.976,0.976l0.743-0.743c0.209,0.122,0.433,0.217,0.673,0.28v1.05h1.38 v-1.05c0.24-0.063,0.464-0.158,0.673-0.28l0.743,0.743l0.976-0.976l-0.743-0.743c0.122-0.209,0.217-0.433,0.28-0.673H21.393z  M17.725,11.552c-0.752,0-1.362-0.61-1.362-1.362c0-0.752,0.61-1.362,1.362-1.362c0.752,0,1.362,0.61,1.362,1.362 C19.087,10.942,18.477,11.552,17.725,11.552z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychiatry);
export default __webpack_public_path__ + "static/media/psychiatry.8ca96f69a25ad3851716abc42ac78e21.svg";
export { ForwardRef as ReactComponent };